import { inject, injectable } from 'inversify';
import CreditCardsRepository from 'src/features/creditCards/data/CreditCardsRepository';
import { AxiosError } from 'axios';
import { getOpenPayErrorMessage } from 'src/utils/cards/getOpenPayErrorMessage';
import { UnknownError } from 'src/utils/errors/UnknownError';

export interface SaveOpenPayCardParams {
  userId: number;
  accessToken: string;
  token: string;
  device_session_id: string;
}

@injectable()
class SaveOpenPayCardUseCase {
  @inject(CreditCardsRepository)
  private readonly creditCardsRepository!: CreditCardsRepository;

  public async execute(params: SaveOpenPayCardParams) {
    try {
      const data = await this.creditCardsRepository.saveCreditCard({
        ...params,
        payment_method: 'openpay',
      });

      return data;
    } catch (error) {
      if (
        error instanceof AxiosError &&
        error.response &&
        error.response.data?.code
      ) {
        const openPayErrorCode = error.response.data.code;
        const errorMsg = getOpenPayErrorMessage(openPayErrorCode);

        throw new Error(errorMsg);
      }

      throw new UnknownError(error);
    }
  }
}

export default SaveOpenPayCardUseCase;
